import { Flex, Icon, Stack } from '@chakra-ui/react';
import { IconEdit } from '@tabler/icons';
import { EditModal } from 'components/modal/EditModal';
import { averageTicketMessages } from 'pages/admin/demand/averageTicket/variables/averageTicketMessages';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';

export function RowEdit(props) {
	const { linkBtnEdit } = props;

	return (
		<Flex
			cursor='pointer'
			h='max-content'
			w='max-content'
		>
			<Stack
				direction='row'
				alignSelf={{ base: 'unset', md: 'flex-end' }}
				spacing='8px'
			>
				<NavLink to={linkBtnEdit}>
					<Icon
						data-test='link-editar'
						color='secondaryGray.500'
						as={IconEdit}
						w='20px'
						h='20px'
					/>
				</NavLink>
			</Stack>
		</Flex>
	);
}

export function RowEditIcon(props) {
	return (
		<Icon
			data-test='link-editar'
			color='secondaryGray.500'
			as={IconEdit}
			w='20px'
			h='20px'
			style={{ cursor: 'pointer' }}
			onClick={props.onClick}
		/>
	);
}

export function RowEditModal(props) {
	const { row } = props;
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			<Icon
				data-test='link-editar'
				color='secondaryGray.500'
				as={IconEdit}
				w='20px'
				h='20px'
				style={{ cursor: 'pointer' }}
				onClick={() => setIsOpen(true)}
			/>
			<EditModal
				id={row.id}
				checked={false}
				title={averageTicketMessages.SCREEN_TITLES.EDIT_AVERAGE_TICKET}
				text={averageTicketMessages.MSG_EDIT_AVERAGE_TICKET_INSTRUCTION}
				firstLabel={averageTicketMessages.LABELS.PRODUCT}
				secondLabel={averageTicketMessages.LABELS.AVERAGE_TICKET}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				showSwitch={false}
				showRecalculate={false}
			/>
		</>
	);
}
